import * as React from 'react'
import { useMapEvents, Marker } from 'react-leaflet'
import L from 'leaflet';

import iconShadow from "leaflet/dist/images/marker-icon-2x.png";

// let DefaultIcon = L.icon({
//     iconSize: [25, 41],
//     iconAnchor: [10, 41],
//     popupAnchor: [2, -40],
//     iconUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
//     shadowUrl: iconShadow,
// });

// @ts-ignore
// delete L.Icon.Default.prototype._getIconUrl;

// L.Icon.Default.mergeOptions({
//     iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//     iconUrl: require('leaflet/dist/images/marker-icon.png'),
//     shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
//     iconSize: [25, 41],
//     iconAnchor: [100, 41],
//     popupAnchor: [2, -40],
// });

// L.Marker.prototype.options.icon = DefaultIcon;

interface IProps {
    location: any;
    onClick: any
}

const greenIcon = new L.Icon({
    iconUrl: iconShadow,
    iconSize: [30, 50], // size of the icon
    iconAnchor: [18, 55], // point of the icon which will correspond to marker's location
    popupAnchor: [0, -51] // point from which the popup should open relative to the iconAnchor
});

export const MapHelper = ({ location = [], onClick }: IProps) => {
    const map = useMapEvents({
        click: onClick,
    })

    React.useEffect(()=>{
        if( location?.length ){
            map.flyTo(location, map.getZoom())
        }
    }, []);

    return location?.length === 0 ? null : <Marker icon={greenIcon} position={location}/>;
}